import { render } from "./aboutPcIndex.vue?vue&type=template&id=40e901dc"
import script from "./aboutPcIndex.vue?vue&type=script&lang=js"
export * from "./aboutPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__